import { useState, useCallback } from 'react';
import { ReprocessMode, ReprocessModalState, UseReprocessModalReturn } from './types';

export const useReprocessModal = (): UseReprocessModalReturn => {
  const [state, setState] = useState<ReprocessModalState>({
    mode: null,
    isOpen: false,
  });

  const openModal = useCallback(() => {
    setState({
      mode: 'selection',
      isOpen: true,
    });
  }, []);

  const closeModal = useCallback(() => {
    setState({
      mode: null,
      isOpen: false,
    });
  }, []);

  const setMode = useCallback((mode: ReprocessMode) => {
    setState((prev) => ({ ...prev, mode }));
  }, []);

  const selectAsync = useCallback(() => setMode('async-confirm'), [setMode]);

  const selectSync = useCallback(() => setMode('sync-loading'), [setMode]);

  const confirmAsync = useCallback(() => setMode('async-info'), [setMode]);

  const showAsyncInfo = useCallback(() => setMode('async-info'), [setMode]);

  return {
    state,
    actions: {
      openModal,
      closeModal,
      selectAsync,
      selectSync,
      confirmAsync,
      showAsyncInfo,
    },
  };
};
